import { render, staticRenderFns } from "./ConsultaLegislacao.vue?vue&type=template&id=b7d8da5e"
import script from "./ConsultaLegislacao.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultaLegislacao.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports